import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import { getApiUrl, showDialog, getLocaleText } from '@/utils/tools'
import store from '@/store'
import { AppGettersTypes, AppMutationTypes } from '@/store/modules/app'

// create an axios service
const service = axios.create({
  baseURL: getApiUrl(),
  timeout: 5000, // request timeout
  headers: {
    'Content-Type': 'application/json'
  },
  responseType: 'json'
})

// request interceptor
service.interceptors.request.use((config: AxiosRequestConfig) => {
  // 取最新的 store data
  config.headers!['Accept-Language'] = store.getters[AppGettersTypes.GET_LANG]

  return config
})

// response interceptor
service.interceptors.response.use(
  (response: AxiosResponse) => {
    // console.log('response-->', response)
    return response
  },
  (error: AxiosError) => {
    // console.log('error-->', error)
    errorHandler(error)
    store.commit(AppMutationTypes.SET_ISLOADING, false)
    return Promise.reject(error.response)
  }
)

const errorHandler = (error: any) => {
  // axios timeout
  if (error.code === 'ECONNABORTED' && error.message.includes('timeout')) {
    showDialog(
      getLocaleText('REMINDER'),
      getLocaleText('OPERATION_TIMEOUT'),
      () => {
        // confirm
      },
      () => {
        // cancel
      }
    )
    return
  }

  if (!error.response) return
  switch (error.response.status) {
    case 400: // Failure
    case 401: // Unauthorized
    case 403: // Access denied
    case 422: // Parameter error
    case 429: // Too many requests
    case 503: // Unavailable
      showDialog(
        getLocaleText('REMINDER'),
        error.response.data.error.message,
        () => {
          // confirm
        },
        () => {
          // cancel
        }
      )
      break
    case 500: // Server error
      showDialog(
        getLocaleText('REMINDER'),
        getLocaleText('SYSTEM_ERROR'),
        () => {
          // confirm
        },
        () => {
          // cancel
        }
      )
      break
    case 504: // Cloudflare error
      showDialog(
        getLocaleText('REMINDER'),
        getLocaleText('OPERATION_TIMEOUT'),
        () => {
          // confirm
        },
        () => {
          // cancel
        }
      )
      break
    default:
      // console.log(getLocaleText('SYSTEM_MAINTENANCE'))
      showDialog(
        getLocaleText('REMINDER'),
        getLocaleText('SYSTEM_MAINTENANCE'),
        () => {
          // confirm
        },
        () => {
          // cancel
        }
      )
      break
  }
}

export default service
